import { render, staticRenderFns } from "./SlidingPanel.vue?vue&type=template&id=5f29e8d5&"
import script from "./SlidingPanel.vue?vue&type=script&lang=js&"
export * from "./SlidingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlidingPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports